export default {
    init() {

        $(document).ready(function () {
            $(".agence").addClass("active_link");
            $(".module-wysiwyg .row").eq(0).addClass('justify-content-start');
            $(".module-wysiwyg .row").eq(1).addClass('justify-content-end');
            $(".module-wysiwyg .row").eq(2).addClass('justify-content-start');
            $(".module-wysiwyg .row").eq(3).addClass('justify-content-end');

            if ($(".page-template-template-rules")[0]) { 
                $(".module-wysiwyg .row").eq(0).addClass('justify-content-center');
            }
        });
        
        /* Script for sequencing the video */
        if ($(".custom-template-culture")[0]) {

            $(window).on("scroll", function () {
                $('.custom-template-culture > [class^="module-"]').each(function () {
                    var topPosition = $(this)[0].offsetTop;

                    if ($(window).scrollTop() > topPosition - 160) {
                        if ($(this).is($(".module-wysiwyg")[0])) {
                            $(".culture-link").find("div").removeClass("active_link");
                            $(".agence").addClass("active_link");                            

                        } else if ($(this).is($(".module-text-blocs"))) {
                            $(".culture-link").find("div").removeClass("active_link");
                            $(".after-work").addClass("active_link");

                        } else if ($(this).is($(".module-central-img")[1])) {
                            $(".culture-link").find("div").removeClass("active_link");
                            $(".experience").addClass("active_link");

                        } else if ($(this).is($(".module-wysiwyg")[2])) {
                            $(".culture-link").find("div").removeClass("active_link");
                            $(".experience").addClass("active_link");
                        } else if ($(this).is($(".module-wysiwyg")[3])) {
                            $(".culture-link").find("div").removeClass("active_link");
                            $(".activites").addClass("active_link");
                        }

                        if ($(this).find(".theme-dark").length != 0 || $(this).find(".theme-red-gradient").length != 0) {
                            $(".culture-banner").removeClass("black-culture-header");
                        } else {
                            $(".culture-banner").addClass("black-culture-header");
                        }

                        
                    }
                });
            });

            $(".culture-link div").on("click", function () {
                var selectedLink = $(this);
                $(".culture-link div").removeClass("active_link");
                selectedLink.addClass("active_link");

                if (selectedLink.hasClass("agence")) {
                    $('html,body').animate({
                        scrollTop: $($(".module-text-blocs")).offset().top
                    }, 'slow');
                } else if (selectedLink.hasClass("after-work")) {
                    $('html,body').animate({
                        scrollTop: $($(".module-wysiwyg")[0]).offset().top
                    }, 'slow');
                } else if (selectedLink.hasClass("experience")) {
                    $('html,body').animate({
                        scrollTop: $($(".module-wysiwyg")[1]).offset().top
                    }, 'slow');
                } else if (selectedLink.hasClass("activites")) {
                    $('html,body').animate({
                        scrollTop: $($(".module-wysiwyg")[2]).offset().top
                    }, 'slow');
                }
            })
        }
    },
};